import script from "./HealthAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./HealthAnalysis.vue?vue&type=style&index=0&id=64b50662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b50662"]])

export default __exports__